module.exports = __webpack_public_path__ + "static/4-40c55305fa04325e29283dcaabb318d3.jpg";